import axios from 'axios';
import { API_URL } from '../config/apiConfig';

const authHeaders = () => ({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('token')}`,
});

// Available rule types with labels, descriptions and required params.
export const getWorkflowRuleTypes = async () => {
    const response = await axios.get(`${API_URL}/workflow/rule-types`, {
        headers: authHeaders(),
    });
    return response.data;
};

// Overview: workflowActive flag, rules and pending task count.
export const getWorkflowOverview = async (affiliateId) => {
    const response = await axios.get(`${API_URL}/workflow/${affiliateId}`, {
        headers: authHeaders(),
    });
    return response.data;
};

// Master switch for the whole workflow.
export const setWorkflowActive = async (affiliateId, active) => {
    const response = await axios.put(
        `${API_URL}/workflow/${affiliateId}/active`,
        { active },
        { headers: authHeaders() }
    );
    return response.data;
};

export const createWorkflowRule = async (affiliateId, rule) => {
    const response = await axios.post(
        `${API_URL}/workflow/${affiliateId}/rules`,
        rule,
        { headers: authHeaders() }
    );
    return response.data;
};

export const updateWorkflowRule = async (ruleId, rule) => {
    const response = await axios.put(`${API_URL}/workflow/rules/${ruleId}`, rule, {
        headers: authHeaders(),
    });
    return response.data;
};

export const deleteWorkflowRule = async (ruleId) => {
    const response = await axios.delete(`${API_URL}/workflow/rules/${ruleId}`, {
        headers: authHeaders(),
    });
    return response.data;
};

// status: 'pending' | 'completed'
export const getWorkflowTasks = async (affiliateId, status = 'pending') => {
    const response = await axios.get(`${API_URL}/workflow/${affiliateId}/tasks`, {
        params: { status },
        headers: authHeaders(),
    });
    return response.data;
};

export const completeWorkflowTask = async (taskId) => {
    const response = await axios.patch(
        `${API_URL}/workflow/tasks/${taskId}/complete`,
        {},
        { headers: authHeaders() }
    );
    return response.data;
};

export const completeAllWorkflowTasks = async (affiliateId) => {
    const response = await axios.patch(
        `${API_URL}/workflow/${affiliateId}/tasks/complete-all`,
        {},
        { headers: authHeaders() }
    );
    return response.data;
};
